import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {PdfViewerComponent} from 'ng2-pdf-viewer';

@Component({
  selector: 'app-modal-preview-photo-doc',
  templateUrl: './modal-preview-photo-doc.component.html',
  styles: [
  ]
})
export class ModalPreviewPhotoDocComponent extends ExcTranslation implements OnInit {


  @ViewChild(PdfViewerComponent) pdfViewerComponent!: PdfViewerComponent;
  @Input() data: any;
  isLoading = true;
  private _currentResource: any;
  get currentResource(): any {
    return this._currentResource;
  }

  set currentResource(value: any) {
    this._currentResource = value;
  }
  constructor(
    private modal: ExgModalService) {
    super();
  }

  ngOnInit(): void {
    if (this.data.url) {
      this.currentResource = this.data.url;
    }
    else {
      this.modal.close();
    }
  }

  pdfLoaded(): void {
    this.isLoading = false;
  }

  close(): void {
    this.modal.close();
  }
}
